import { apiUrl } from "./api";
import { getToken } from "./authHelper";

export const supportFileTypes = ["image/png", "image/jpeg", "image/webp", "image/gif", "application/pdf", "text/plain", "application/zip"];
export const supportMaxFileSize = 5 * 1024 * 1024;
export const supportMaxFiles = 3;
export const supportMaxTotalFileSize = 12 * 1024 * 1024;
export const supportFileAccept = ".png,.jpg,.jpeg,.webp,.gif,.pdf,.txt,.zip";
const supportTypesByExtension = {
  png: "image/png", jpg: "image/jpeg", jpeg: "image/jpeg", webp: "image/webp", gif: "image/gif",
  pdf: "application/pdf", txt: "text/plain", zip: "application/zip"
};

const supportTypeForFile = (file) => {
  const extension = file.name.split(".").pop()?.toLowerCase();
  const extensionType = supportTypesByExtension[extension];
  if (!extensionType) return "";
  if (supportFileTypes.includes(file.type) && file.type !== extensionType) return "";
  return extensionType;
};

export const filesToPayload = (files) => Promise.all(files.map((file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => resolve({ name: file.name, type: supportTypeForFile(file), data: reader.result });
  reader.onerror = () => reject(new Error(`Unable to read ${file.name}.`));
  reader.readAsDataURL(file);
})));

export const validateSupportFiles = (files, existingFiles = []) => {
  const combined = [...existingFiles, ...files];
  if (combined.length > supportMaxFiles) return `You can attach up to ${supportMaxFiles} files.`;
  if (combined.reduce((total, file) => total + file.size, 0) > supportMaxTotalFileSize) return "Attachments must total no more than 12 MB.";
  const invalid = files.find((file) => !supportTypeForFile(file) || file.size > supportMaxFileSize || file.size === 0);
  return invalid ? `${invalid.name} is not supported. Choose PNG, JPG, WebP, GIF, PDF, TXT or ZIP files up to 5 MB.` : "";
};

export const downloadSupportAttachment = async (attachment) => {
  const response = await fetch(apiUrl(`/api/support/attachments/${attachment.id}`), {
    headers: { Authorization: `Bearer ${getToken()}` }
  });
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.message || "Unable to download this attachment.");
  }
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = attachment.name;
  link.click();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
};
